import { createSlice } from "@reduxjs/toolkit";

const userDetailsSlice = createSlice({
  name: "userDetails",
  initialState: {
    userDetails: {
      token: sessionStorage.getItem("AccessToken") === null ? "" : sessionStorage.getItem("AccessToken"),
    },
    // profileDetails: {
    //   currentUserDetails: JSON.parse(sessionStorage.getItem("CurrentUserDetails")) === null ? " " : JSON.parse(sessionStorage.getItem("CurrentUserDetails"))
    // },


  },
  reducers: {
    setCurrentUserDetails: (state, action) => {
      state.userDetails.token = action.payload;
    },
  },
});

export const { setCurrentUserDetails } = userDetailsSlice.actions;
export default userDetailsSlice.reducer;
